import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CognitoService } from '../services/cognito.service';
import { UserRoles } from '../models/user-roles.enum';
import { getCurrentUser } from 'aws-amplify/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(
    private cognitoService: CognitoService,
    private router: Router
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      const currentUser = await getCurrentUser();
      
      if (!currentUser) {
        this.router.navigate(['/signin']);
        return false;
      }
      try {
        const user = await this.cognitoService.getUser();
        if (user.role === UserRoles.PENDING_USER) {
          this.router.navigate(['/signin']);
          return false;
        }
        return true;
      } catch (roleError) {
        this.router.navigate(['/signin']);
        return false;
      }
      
    } catch (error) {
      this.router.navigate(['/signin']);
      return false;
    }
  }
}
